import clsx from 'clsx';
import type { ChangeEvent } from 'react';

import styles from './FormElement.module.css';

type FormElementVersionProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
};

export const FormElementVersion = ({ value, onChange, label }: FormElementVersionProps) => {
  const [major, minor, patch] = value.split('.', 3);

  const handleMajorChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const major = event.target.value || '0';
    onChange(`${major}.${minor}.${patch}`);
  };
  const handleMinorChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const minor = event.target.value || '0';
    onChange(`${major}.${minor}.${patch}`);
  };
  const handlePatchChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const patch = event.target.value || '0';
    onChange(`${major}.${minor}.${patch}`);
  };

  return (
    <div className="block font-sans">
      {Boolean(label) && <span className="text-darkgray text-sm">{label}</span>}
      <div className="flex">
        <select
          name="major"
          className={clsx(
            styles.interactiveBorderEdit,
            'appearance-none bg-transparent border border-solid border-gray rounded outline-none py-1 px-2 text-sm text-center font-sans',
          )}
          value={major}
          onChange={handleMajorChange}
        >
          {Array.from({ length: 100 }).map((_, idx) => (
            <option key={`major_${idx}`} value={idx}>
              {idx}
            </option>
          ))}
        </select>
        <span className="text-xl mx-2">.</span>
        <select
          name="minor"
          className={clsx(
            styles.interactiveBorderEdit,
            'appearance-none bg-transparent border border-solid border-gray rounded outline-none py-1 px-2 text-sm text-center font-sans',
          )}
          value={minor}
          onChange={handleMinorChange}
        >
          {Array.from({ length: 100 }).map((_, idx) => (
            <option key={`minor_${idx}`} value={idx}>
              {idx}
            </option>
          ))}
        </select>
        <span className="text-xl mx-2">.</span>
        <select
          name="patch"
          className={clsx(
            styles.interactiveBorderEdit,
            'appearance-none bg-transparent border border-solid border-gray rounded outline-none py-1 px-2 text-sm text-center font-sans',
          )}
          value={patch}
          onChange={handlePatchChange}
        >
          {Array.from({ length: 100 }).map((_, idx) => (
            <option key={`patch_${idx}`} value={idx}>
              {idx}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
